<template>
  <div>
    <GlobalForm
      class="global-form"
      :init-data="initData"
      :form-item-list="formItemList"
      :inline="true"
      :labelWidth="100"
      :needBtnLoading="true"
      round
      @handleConfirm="handleConfirm"
      confirmBtnName="查询"
    >
      <el-button
        icon="el-icon-plus"
        slot="AddSlot"
        type="primary"
        @click="addGif"
        >添加赠品</el-button
      >
    </GlobalForm>
    <el-dialog
      class="add-form"
      title="新增赠品"
      :visible.sync="addShow"
      :close-on-click-modal="false"
      width="500px"
      @closed="addDialogClose"
    >
      <el-form
        :model="formDataDialog"
        :rules="formRulesDialog"
        ref="ruleForm"
        label-width="106px"
      >
        <el-form-item label="赠品名称" prop="giftName">
          <el-input
            size="small"
            v-model="formDataDialog.giftName"
            placeholder="请输入赠品名称（20字内）"
            maxlength="20"
          ></el-input>
        </el-form-item>
        <el-form-item label="赠品类型" required>
          <el-radio-group v-model="formDataDialog.giftType">
            <el-radio label="01">换新补贴</el-radio>
            <el-radio label="02">回收赠礼</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="活动最高补贴" v-if="formDataDialog.giftType == '01'" prop="giftPrice">
          <el-input
            size="small"
            placeholder="请输入正整数"
            v-model.trim="formDataDialog.giftPrice"
            @input="formDataDialog.giftPrice=formDataDialog.giftPrice.replace(/[^[0-9]/g,'').replace(/^0[0-9]*/g, '')"
          >
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="赠品价值" v-if="formDataDialog.giftType == '02'" prop="giftPrice">
          <el-input
            size="small"
            placeholder="请输入正整数"
            v-model.trim="formDataDialog.giftPrice"
            @input="formDataDialog.giftPrice=formDataDialog.giftPrice.replace(/[^[0-9]/g,'').replace(/^0[0-9]*/g, '')"
          >
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item :label="formDataDialog.giftType == '01'?'换新活动海报':'赠品介绍'">
          <div style="display:flex;">
            <ElImgUpload
              :exist-image="formDataDialog.giftPosters"
              @handleDelete="handleUploadDelete"
              @handleChange="handleUploadChange($event)"
            />
            <span style="text-decoration: underline; cursor: pointer; color: #0981ff;margin-left:20px" @click="seeExample">查看示例</span>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="addShow = false">取 消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="btnLoading"
          @click="submitAdd"
          >确认</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import _api from "@/utils/request";
import ElImgUpload from '../../../components/global/components/elements/upload-element'
export default {
  components: {ElImgUpload},
  data() {
    return {
      initData: {
        giftType: '',
      },
      formItemList: [
        {
          key: "giftName",
          type: "input",
          labelName: "赠品名称",
          placeholder: "请输入赠品名称",
        },
        {
          key: "giftType",
          type: "select",
          labelName: "赠品类型",
          width: 85,
          placeholder: "请选择赠品类型",
          option: [
            {
              value: "",
              label: "全部",
            },
            {
              value: "01",
              label: "换新补贴",
            },
            {
              value: "02",
              label: "回收赠礼",
            },
          ],
        },
        {
          key: "entryTime",
          type: "pickerOptions",
          labelName: "创建时间",
          clearable: true
        },
      ],
      addShow: false,
      btnLoading: false,
      formDataDialog: {
        giftName: "",
        giftType: "01",
        giftPrice: "",
        giftPosters: ""
      },
      formRulesDialog: {
        giftName: [
          {
            required: true,
            trigger: "blur",
            message: "请输入赠品名称",
          },
        ],
        giftPrice: [
          {
            required: true,
            trigger: "blur",
            message: "金额不能为空",
          },
        ],
      },
    };
  },
  created() {},
  mounted() {},
  methods: {
    handleConfirm(data,cd) {
      let startTime = "";
      let endTime = "";
      if(data){
        if (data.entryTime == null) {
          (startTime = ""), (endTime = "");
        } else {
          (startTime = moment(data.entryTime[0]).format("x")),
            (endTime = moment(data.entryTime[1]).format("x"));
        }
      }
      let SeachParams = {
        startTime: startTime,
        endTime: endTime,
        giftName: data && data.giftName || "",
        giftType: data && data.giftType || "",
        pageNum: 1,
        pageSize: 10,
        disuseLoding: () => {
          if (typeof cd === 'function') {
            cd()
          }
        },
      };
      this.$store.commit("tagsView/SEACH_PARAMS", SeachParams);
    },
    addGif() {
      this.addShow = true
    },
    // 确认添加
    submitAdd() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          _api.addOrUpdate(this.formDataDialog).then(res=>{
            console.log(res)
            if(res.code===1){
              this.$message.success(res.msg)
              this.addShow = false
              this.handleConfirm()
              this.$refs['ruleForm'].resetFields();
              this.addShow = false
            }
            this.btnLoading = false
          }).catch(()=> {
            this.btnLoading = false
          })
        } else {
          return false;
        }
      });
    },
    //删除图片
    handleUploadDelete () {
			this.formDataDialog.giftPosters = ''
		},
    // 上传图片后，将图片信息保存到对应参数中
		handleUploadChange (url) {
			this.formDataDialog.giftPosters = url
		},
    addDialogClose() {
      this.formDataDialog = {
        giftName: "",
        giftType: "01",
        giftPrice: "",
      };
      this.$refs["ruleForm"].resetFields();
    },
    seeExample() {
      this.$emit("seeExample",this.formDataDialog.giftType)
    }
  },
};
</script>

<style lang="scss" scoped>
.global-form {
  /deep/.el-input__inner {
    width: 160px;
  }
}
.add-form{
  /deep/.el-input-group__append {
    border: 1px solid #0981ff;
    background: #0981ff;
    color: #ffffff;
  }
  // /deep/.el-form-item {
  //   margin-bottom: 10px;
  // }
  /deep/.el-form-item__content .el-input-group{
    vertical-align: middle;
  }
}
</style>
